<div class="flex gap-4">
  <!--
    El conteo abre la fila (CA1, igual que en core-metrics): cuántas
    facilities antes de cuánto dinero, para que el monto que sigue se lea como
    su tamaño.
  -->
  <selectable-widget
    #swCount
    [exportMode]="exportMode()"
    [selected]="isWidgetSelected(swCount.nativeEl)"
    (widgetToggle)="widgetToggle.emit({ checked: $event, el: swCount.nativeEl })"
    class="card-grey flex h-36 grow flex-col gap-2 p-4">
    <div>
      <small class="font-normal text-surface-500">
        {{ 'Facilities' | uppercase }}
      </small>
      @if (loading()) {
        <p-skeleton height="2rem" width="60%" styleClass="mt-1" />
      } @else {
        <h1 class="font-body font-bold">{{ facilities() ?? '—' }}</h1>
        @if (originators(); as count) {
          <!-- CA1: no es el mismo número que el de facilities -- un
               originador puede tener varias. -->
          <small class="font-normal text-surface-500">
            {{ count }} <span i18n>originators</span> ·
            {{ facilities() }} <span i18n>facilities</span>
          </small>
        }
      }
    </div>
  </selectable-widget>

  <selectable-widget
    #swSize
    [exportMode]="exportMode()"
    [selected]="isWidgetSelected(swSize.nativeEl)"
    (widgetToggle)="widgetToggle.emit({ checked: $event, el: swSize.nativeEl })"
    class="card-grey flex h-36 grow flex-col gap-2 p-4">
    <div>
      <small class="font-normal text-surface-500">
        {{ 'Total facility size' | uppercase }}
      </small>
      @if (loading()) {
        <p-skeleton height="2rem" width="60%" styleClass="mt-1" />
      } @else {
        <h1 class="font-body font-bold">
          @if (totalFacilitySize(); as size) {
            <currency-amount [value]="size" [currency]="currency()" />
          } @else {
            —
          }
        </h1>
        <small class="font-normal text-surface-500" i18n>
          Maximum credit, all lenders
        </small>
      }
    </div>
  </selectable-widget>

  <selectable-widget
    #swShare
    [exportMode]="exportMode()"
    [selected]="isWidgetSelected(swShare.nativeEl)"
    (widgetToggle)="widgetToggle.emit({ checked: $event, el: swShare.nativeEl })"
    class="card-grey flex h-36 grow flex-col gap-2 p-4">
    <div>
      <small class="font-normal text-surface-500">
        {{ 'Your participation' | uppercase }}
      </small>
      @if (loading()) {
        <p-skeleton height="2rem" width="60%" styleClass="mt-1" />
      } @else if (participationPct() !== undefined) {
        <!-- La comparación es explícita y no la falsedad del valor: un 0%
             capturado es un dato, no una ausencia. -->
        <h1 class="font-body font-bold">
          {{ participationPct() | number: '1.0-1' }}%
        </h1>
        @if (participationExcluded()) {
          <!-- Alguna facility quedó fuera del cociente: "the facilities you
               are in" afirmaría que las midió a todas (MR !1366 S3). -->
          <small class="font-normal text-surface-500" i18n>
            of the {{ participationCounted() }}
            {{ participationCounted() === 1 ? 'facility' : 'facilities' }} with
            both amounts
          </small>
        } @else {
          <small class="font-normal text-surface-500" i18n>
            of the facilities you are in
          </small>
        }
      } @else {
        <!--
          Ninguna facility tiene los dos montos capturados. Se dice que no se
          sabe en vez de pintar 0%, que afirmaría que no participás en nada.
        -->
        <h1 class="font-body font-bold">—</h1>
        <small class="font-normal text-surface-500" i18n>
          Participation unknown
        </small>
      }
    </div>
  </selectable-widget>

  <selectable-widget
    #swTop
    [exportMode]="exportMode()"
    [selected]="isWidgetSelected(swTop.nativeEl)"
    (widgetToggle)="widgetToggle.emit({ checked: $event, el: swTop.nativeEl })"
    class="card-grey flex h-36 grow flex-col gap-2 p-4">
    <div>
      <small class="font-normal text-surface-500">
        {{ 'Top concentration' | uppercase }}
      </small>
      @if (loading()) {
        <p-skeleton height="2rem" width="60%" styleClass="mt-1" />
      } @else {
        @if (topConcentration(); as top) {
          <h1 class="font-body font-bold">
            <currency-amount [value]="top.amount" [currency]="currency()" />
          </h1>
          <small class="font-normal text-surface-500">
            {{ top.name }} <span i18n>· largest single exposure</span>
          </small>
        } @else {
          <h1 class="font-body font-bold">—</h1>
          <small class="font-normal text-surface-500" i18n>
            No commitment reported yet
          </small>
        }
      }
    </div>
  </selectable-widget>
</div>
